export interface MerchantImageGalleryInit {
  id: number;
  mainUrl: string;
  thumbnailUrl: string;
}

export default class MerchantImageGallery {
  public readonly id: number;
  public readonly mainUrl: string;
  public readonly thumbnailUrl: string;

  constructor(init: MerchantImageGalleryInit) {
    this.id = init.id;
    this.mainUrl = init.mainUrl;
    this.thumbnailUrl = init.thumbnailUrl;
  }
}
